import React, { useEffect, useRef, useState } from "react";
import "../styles/About.css";
import Navbar from "../components/Navbar";
import scale from "../assets/images/scale.webp";
import emailjs from "emailjs-com";
import { Helmet } from "react-helmet";
import HomeContactSection from "../components/HomeContactSection";



function About() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
    time: new Date().toLocaleString(),
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess(false);
    setError(false);

    const templateParams = {
      name: formData.name,
      email: formData.email,
      message: formData.message,
      time: new Date().toLocaleString(),
    };

    emailjs
      .send(
        "service_TejCodex",
        "template_9w26kov",
        templateParams,
        "-1wDk-Z48uDBTDyvr"
      )
      .then(
        () => {
          setLoading(false);
          setSuccess(true);
          setFormData({ name: "", email: "", message: "" });
        },
        () => {
          setLoading(false);
          setError(true);
        }
      );
  };

  useEffect(() => {
    let timer;
    if (success || error) {
      timer = setTimeout(() => {
        setSuccess(false);
        setError(false);
      }, 8000); // 8 seconds = 8000 ms
    }
    return () => clearTimeout(timer);
  }, [success, error]);

  return (
    <div className="Aabout">
      <Helmet>
        <title>About TejCodex | N. Tejeshwar's Law Notes Platform</title>
        <meta name="description" content="Learn about TejCodex — a free law study platform for Law students, founded by N. Tejeshwar. Discover our mission to simplify LLB education." />
        <link rel="canonical" href="https://tejcodex.com/about" />
        <meta property="og:title" content="About TejCodex" />
        <meta property="og:description" content="TejCodex is a student-built platform providing free, structured LLB notes aligned with the Osmania University syllabus." />
        <meta property="og:url" content="https://tejcodex.com/about" />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "AboutPage",
          "name": "About TejCodex",
          "url": "https://tejcodex.com/about",
          "description": "TejCodex provides free Law Notes for OU LLB students",
          "author": {
            "@type": "Person",
            "name": "N. Tejeshwar"
          }
        })}</script>
      </Helmet>
      <Navbar />
      <div className="Amsg-trapezium">
        <div className="Amsg-trapezium-black1"></div>
        <div className="Amsg-trapezium-white1">
        </div>
      </div>
      <div className="Amsg-trapezium-black2"></div>
      <div className="Amsg-trapezium-white2">
      </div>
      <h1 className="Aheading">About TejCodex...</h1>

      <section className="Aabout-section">
        <p className="Aabout-subtext">
          “TejCodex is your trusted law companion, offering well-structured
          notes and PYQs designed strictly as per the OU syllabus.📚
          <br />
          ✨ Our aim is to simplify learning, so you can focus on
          understanding concepts and succeeding in exams with ease. 🎓”
        </p>

        <div className="Aabout-blocks">
          <div className="Aabout-block">
            <img src={scale} alt="Scale" className="Ablock-img" />
            <div className="Ablock-inner">
              <h3>📚 Structured Learning</h3>
              <p>
                Notes are organized course-wise, semester-wise, and subject-wise
                to match the Osmania University syllabus.
              </p>
            </div>
          </div>

          <div className="Aabout-block">
            <img src={scale} alt="Scale" className="Ablock-img" />
            <div className="Ablock-inner">
              <h3>📝 Smartly Prepared</h3>
              <p>
                Content is prepared using Notebook LM with both online and
                offline resources to ensure accuracy and clarity.
              </p>
            </div>
          </div>

          <div className="Aabout-block">
            <img src={scale} alt="Scale" className="Ablock-img" />
            <div className="Ablock-inner">
              <h3>🎯 Exam-Focused</h3>
              <p>
                Every note and PYQ is simplified to help you understand quickly
                and perform confidently in exams.
              </p>
            </div>
          </div>

          <div className="Aabout-block">
            <img src={scale} alt="Scale" className="Ablock-img" />
            <div className="Ablock-inner">
              <h3>🤝 By Students, For Students</h3>
              <p>
                TejCodex is built to make law study easier, helping every
                learner access free resources anytime, anywhere.
              </p>
            </div>
          </div>
        </div>

        <p className="Aabout-final">
          ⚖️ Together, we make law learning simpler and success more achievable.
          🎓
        </p>
      </section>

      <section className="Aabout-section aim-section">
        <h2 className="aim-heading">Aim Of TejCodex...</h2>
        <div className="aim-content">
          <div className="aim-text">
            <p>
              🎯 The aim of <strong>TejCodex</strong> is to provide
              well-organized and accessible 📚 LLB notes to students. These
              notes are prepared using resources available across trusted 🌐
              online platforms and refined with the help of{" "}
              <strong>NotebookLM</strong> 🤖 to ensure clarity and quality.
            </p>
          </div>

          <div className="aim-quote">
            <blockquote>
              ⚖️ “The study of law is not just about memorizing rules, but about
              understanding justice, reasoning, and the spirit of fairness that
              shapes society.” ✨
            </blockquote>
          </div>
        </div>
      </section>

      <section className="Aabout-section Aworks-section">
        <h2 className="aim-heading">How TejCodex Works...</h2>

        <div className="Aworks-step">
          <h3>📖 Collecting & Organizing Resources</h3>
          <p>
            TejCodex gathers study materials and references from trusted online
            platforms 🌐 and academic resources. These are carefully reviewed,
            filtered, and organized to match the syllabus and practical needs of
            LLB students.
          </p>
        </div>

        <div className="Aworks-step">
          <h3>🤖 Refining Notes </h3>
          <p>
            Once resources are collected, <strong>Online Tools </strong> helps
            refine and structure the content. This ensures the notes are clear,
            concise, and student-friendly ✨ — making it easier for learners to
            grasp complex legal concepts.
          </p>
        </div>
      </section>

      <section className="Aabout-section origin-section">
        <h2 className="aim-heading">The Codex Origin...</h2>
        <div className="origin-content">
          <p>
            🌟 <strong>TejCodex</strong> was born out of necessity. While there
            are countless resources scattered across the internet, there was no
            single platform that purely focused on providing well-structured
            <strong> LLB notes</strong> tailored to the{" "}
            <strong>Osmania University (OU) syllabus</strong>. 📚
          </p>
          <p>
            To bridge this gap, TejCodex was created as a centralized hub 🏛️ —
            where law students can easily access simplified, high-quality, and
            syllabus-focused notes without the hassle of searching across
            multiple sources. ✨
          </p>
          <p>
            This initiative reflects a vision to support every law student’s
            journey ⚖️, ensuring that learning becomes more efficient,
            organized, and accessible. 🚀
          </p>
        </div>
      </section>

      <section className="Aabout-section join-section">
        <h2 className="aim-heading">Be Part of TejCodex...</h2>
        <div className="join-content">
          <p>
            🤝 <strong>TejCodex</strong> is not just a platform, it’s a growing
            community of learners and future legal professionals. Your support
            means a lot!
          </p>
          <p>
            📢 Share this website with your friends and classmates so more
            students can benefit from organized and accessible{" "}
            <strong>LLB notes</strong>. Together, we can make learning law
            easier and more collaborative. 🌍
          </p>
          <p>
            📝 We value your feedback, suggestions, and even corrections! If you
            notice any errors or have ideas to improve, don’t hesitate to reach
            out. Every contribution helps us grow and serve the law community
            better. 💡✨
          </p>
        </div>
      </section>

      <HomeContactSection
        scale={scale}
        formData={formData}
        loading={loading}
        success={success}
        error={error}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
      />
      <footer className="afooter-section">
        <div className="afooter-top">
          <img src={scale} alt="Scale" className="afooter-logo" />
          <span className="afooter-title">TejCodex.com</span>
          <span className="afooter-rights">© 2025 All rights reserved.</span>
        </div>

        <div className="afooter-links">
          <a href="/">Home</a> |<a href="/notes"> Notes</a> |
          <a href="/pyqs"> PYQs</a> | <a href="/aibe-preparation"> AIBE</a> | <a href="/about"> About Us</a> |<a href="/contact"> Contact Us</a>
        </div>
      </footer>
    </div>
  );
}

export default About;
